<template>

	<div fluid style="width: 100%; height: 100%;" width="100%" height="100%">
		
		<v-card tile class="ai-cardPaneScrollTweakAuto elevation-0" :width="leftMenuPaneWidth" height="100%"><!--  -->
			
			<!-- -------------------------------------------- -->
			<!--   Content toolbar -->
			<!-- -------------------------------------------- -->

			<v-toolbar v-show="showContentMenu" color="secondary" dark :height="smallTitleBarHeight" width="100%">
				<v-btn v-if="agile.loggedInUser.superAdmin" class="" icon x-small @click="showContentMenu = true; showSharedContentMenu = !showSharedContentMenu;">
					<v-icon class="dsa">{{ (showSharedContentMenu && showContentMenu) ? 'mdi-window-maximize' : 'mdi-view-agenda-outline' }}</v-icon>
				</v-btn>
				<div class="ai-small-title-bar pl-1">Content tree</div>

				<v-spacer/>

				<div v-if="agile.loggedInUser.superAdmin">
				<v-btn icon x-small  @click="createContent">
					<v-icon class="">mdi-plus</v-icon>
				</v-btn>

				<v-btn class="ml-2 mr-0" icon x-small  @click="deleteSelectedContentTreeItem">
					<v-icon class="">mdi-trash-can</v-icon>
				</v-btn>
				
				<v-btn class="ml-2 mr-0" icon x-small  @click="$refs.treeComponent.treeOpenNodes = []">
					<v-icon class="">mdi-arrow-collapse-vertical</v-icon>
				</v-btn>

				<v-btn class="ml-2 mr-0" icon x-small  @click="permantentlyDeleteTrash">
					<v-icon class="">mdi-delete-empty</v-icon>
				</v-btn>
				</div>
			</v-toolbar>

			<v-toolbar v-show="false" flat color="toolbarPrimary" :height="toolBarPrimaryHeight" width="100%">

				<v-btn class="ml-n1 pl-1" text small @click="createContent">
					<v-icon style="font-size: 20px;" class="pr-1">mdi-plus-circle-outline</v-icon>
					Create
				</v-btn>
				
				<v-btn class="ml-n1 pl-1" text small @click="deleteSelectedContentTreeItem">
					<v-icon style="font-size: 20px;" class="pr-1">mdi-minus-circle-outline</v-icon>
					Delete
				</v-btn>

				<v-spacer/>
				<v-btn class="ml-n1 pr-2" icon x-small color="#aaaaaa" @click="permantentlyDeleteTrash">
					<v-icon class="pr-1">mdi-trash-can</v-icon>
				</v-btn>

			</v-toolbar>
			
			
			<content-editor-tree v-show="showContentMenu" ref="treeComponent" />



			<!-- -------------------------------------------- -->
			<!--   Shared content toolbar -->
			<!-- -------------------------------------------- -->

			<v-toolbar v-show="showSharedContentMenu" color="secondary" dark :height="smallTitleBarHeight" width="100%">
				<v-btn class="" icon x-small @click="showSharedContentMenu = true; showContentMenu = !showContentMenu;">
					<v-icon class="dsa">{{ (showSharedContentMenu && showContentMenu) ? 'mdi-window-maximize' : 'mdi-view-agenda-outline' }}</v-icon>
				</v-btn>
				<div class="ai-small-title-bar pl-1" style="margin-top: 0px;">Shared content</div>
				<v-spacer/>
				
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon x-small>
							<v-icon class="">mdi-plus</v-icon>
						</v-btn>
					</template>

					<v-list dense>
														
						<!-- Create new view template -->
						<v-list-item @click="createSharedContent">           
							<v-list-item-icon>
								<v-icon>mdi-page-next</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>New shared content</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Create new sorting folder -->
						<v-list-item @click="createSharedContentFolder">           
							<v-list-item-icon>
								<v-icon>mdi-folder-plus</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>Sorting folder</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-menu>

				<v-btn class="ml-2 mr-0" icon x-small  @click="deleteSharedContentTreeItem">
					<v-icon class="">mdi-trash-can</v-icon>
				</v-btn>

				<v-btn class="ml-2 mr-0" icon x-small  @click="$refs.sharedTreeComponent.treeOpenNodes = []">
					<v-icon class="">mdi-arrow-collapse-vertical</v-icon>
				</v-btn>

			</v-toolbar>

			<v-toolbar v-show="false" flat color="toolbarPrimary" :height="toolBarPrimaryHeight" width="100%">

				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn  v-on="on" class="ml-n1 pl-1" text small>
							<v-icon class="pr-1">mdi-plus-circle-outline</v-icon>
							Create
						</v-btn>
					</template>

					<v-list dense>
														
						<!-- Create new view template -->
						<v-list-item @click="createSharedContent">           
							<v-list-item-icon>
								<v-icon>mdi-page-next</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>New shared content</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Create new sorting folder -->
						<v-list-item @click="createSharedContentFolder">           
							<v-list-item-icon>
								<v-icon>mdi-folder-plus</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>Sorting folder</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-menu>
				<!-- <v-btn class="ml-n1 pl-1" text small @click="createSharedContent">
					<v-icon style="font-size: 20px;" class="pr-1">mdi-plus-circle-outline</v-icon>
					Create
				</v-btn> -->
				
				<v-btn class="ml-n1 pl-1" text small @click="deleteSharedContentTreeItem">
					<v-icon style="font-size: 20px;" class="pr-1">mdi-minus-circle-outline</v-icon>
					Delete
				</v-btn>
			</v-toolbar>

			<shared-content-editor-tree v-show="showSharedContentMenu" ref="sharedTreeComponent" />
			

			<!-- -------------------------------------------- -->
			<!--   Bottom toolbar -->
			<!-- -------------------------------------------- -->

			<v-toolbar flat color="toolbarPrimary" :height="toolBarSecondaryHeight" width="100%">
				<div style="font-size: 11px;" class="grey--text text--darken-2" @click="copyToClipboard(activeTreeNodeId)"> {{ activeTreeNodeId }}</div>
				<v-spacer/>
				<div style="font-size: 11px; text-align: right;" class="grey--text text--darken-2"> {{ activeTreeNodeType }}</div>
			</v-toolbar>
			
		</v-card>


		<!-- -------------------------------------------- -->
		<!--   Tab and editor pane -->
		<!-- -------------------------------------------- -->

		<v-card :style="`left: ${leftMenuPaneWidth}px;'`" class="brightBackground ai-cardPaneScrollTweak elevation-0" :width="rightContentPaneWidth" tile height="100%">
			<content-editor-tab-menu ref="tabsComponent" />
		</v-card>

	</div>
	
</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import Vue from 'vue';
import fb from '@/shift/fb';
import agile from "@/shift/agile";
import agileFb from "@/shift/agileFb";
import { AiEventBus } from '@/main';
import ContentEditorTree from "@/components/contenteditor/ContentEditorTree";
import SharedContentEditorTree from "@/components/contenteditor/SharedContentEditorTree";
import ContentEditorTabMenu from "@/components/contenteditor/ContentEditorTabMenu";
//import ViewsSystemSettingsVO from "@/valueobjects/ViewsSystemSettingsVO";


export default
{
	name: "ContentEditor",
	components: { ContentEditorTree, SharedContentEditorTree, ContentEditorTabMenu },

	// ----------------------------------
	//	Data and properties
	// ----------------------------------

	data: () =>
	({
		agile: agile,
		refreshKey: 1,
		showContentMenu: true,
		showSharedContentMenu: false,

		leftPaneWidth: 25,
		leftMenuPaneWidth: 50,
		rightContentPaneWidth: 50,
		hasLoadedInitialContentTree: false,
		hasLoadedInitialSharedContentTree: false,
		hasLoadedInitialSortingFolderTree: false,
		userJustCreatedDocument: null,
		
		unsubscribeLiveFolders: null,
		unsubscribeLiveContent: null,
		unsubscribeLiveSharedContent: null,

		boundOnResize: null,
		activeTreeNodeId: '',
		activeTreeNodeType: '',

	}),


	computed:
	{
		routeKey()
		{
			return this.$route.params.key;
		},
		
		appBarHeight()
		{
			return agile.appBarHeight();
		},

		toolBarPrimaryHeight()
		{
			return agile.toolBarPrimaryHeight();
		},

		toolBarSecondaryHeight()
		{
			return agile.toolBarSecondaryHeight();
		},

		smallTitleBarHeight()
		{
			return agile.smallTitleBarHeight();
		},
		
	},


	// ----------------------------------
	//	VUE: Watcher
	// ----------------------------------

	watch:
	{
		showContentMenu()
		{
			this.onResize();
		},

		showSharedContentMenu()
		{
			this.onResize();
		},

		$route:
		{
			deep: true,

			handler()
			{
				this.$forceUpdate()
				//this.refreshKey += 1;
				//this.$router.go();
			}
		}
		
		
		
		/* {
			$route ()
			{
				console.log("hey");
				//this.show = false;
			}
		}  */
	},


	// ----------------------------------this.$router.go()
	//	VUE: Created and mounted
	// ----------------------------------

	created()
	{
		agileFb;
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);

		this.initializeTreeContentLiveListener();
		//this.initializeSharedTreeContentLiveListener();
		//this.initializeSharedTreeFolderLiveListener();

		AiEventBus.$on('authenticationComplete', this.syncUserStateFromFirestore);
		this.syncUserStateFromFirestore();


	},

	mounted()
	{
		this.onResize();
		document.addEventListener("keydown", this.onKeyPress);
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		copyToClipboard(str)
		{
			str = str.substring(4, str.length);

			const el = document.createElement('textarea');
			el.value = str;
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		},

		// --------------------------------------------------------------------
		//
		//	Create new content
		//
		// --------------------------------------------------------------------

		createContent()
		{
			this.$root.$contentCreateNew('Create new content') // Open dialog box to set name
			.then((returnData) =>
			{
				if (returnData)
				{
					// We store this property, so when we receive the new doucment from
					// firestore later, we can open the new document in the tab menu
					this.userJustCreatedDocument = returnData;

					

					const selectedTreeNodeId = this.$refs.treeComponent.treeActiveItem[0]; // is undefined if nothing is selected in tree

					// Find selected parent item
					let parentNodeId = (selectedTreeNodeId) ? selectedTreeNodeId : 'root' ;
					let positionInTree;

					// Get the order position
					if (selectedTreeNodeId) 
					{
						const selectedItem = agile.getObjectById(this.$refs.treeComponent.treeItems, selectedTreeNodeId);
						
						if (selectedItem && selectedItem.children) // Make sure the content has the children array 
						{
							positionInTree = selectedItem.children.length;
						}
						else
						{
							//this.$root.$alert("Warning", 'You can only add new view items to folders or the root. Your new view item is added to the root instead.');
							positionInTree = this.$refs.treeComponent.treeItems.length;
							parentNodeId = 'root';
						}
					}
					else
					{
						positionInTree = this.$refs.treeComponent.treeItems.length;
					}
					
					


					// Setup command
					const collection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('content');

					collection.add(
					{
						// --------------------------------------------------------------------
						//	
						//	Creation of the content document here!!!
						//	1: Create the wrapper document (for collections of data and to provide metadata)
						//	2: Create the document subcollection, where actual data will reside
						//	3: There will also be a subcollection for archives, which will be
						//	   made when the user starts to edit the document.
						//
						// --------------------------------------------------------------------

						visibility: 'draft',
						trash: false,
						sharedContent: false,
						
						editorMetaData:
						{
							treeNodeLabel: returnData.createdName,
							treeNodeParent: parentNodeId,
							treeNodePosition: positionInTree,
							templateName: returnData.docData.name,
							templateId: returnData.docData.id,
						},

						contentMetaData: returnData.docData.data.settings,

					})
					.then((docRef) =>
					{
						// ------------------------------------------------
						//	Create the real document for content
						// ------------------------------------------------

						// #Todo Make sure that if creation of sub collection document fails, then revert the creation as a whole
						collection.doc(docRef.id).collection('document').doc('content').set(
						{
							name: returnData.createdName,
							trash: false,
						})
						.then(() =>
						{
							//console.log('* Created sub collection doc');
						})
						.catch((error) =>
						{
							console.log('Error creating new sub collection content:', error.message);
						});

					})
					.catch((error) =>
					{
						console.log('Error creating new content:', error.message);
					});


					
				}
			});
		},





		createSharedContent()
		{
			this.$root.$contentCreateNew('Create new shared content') // Open dialog box to set name
			.then((returnData) =>
			{
				if (returnData)
				{
					// We store this property, so when we receive the new doucment from
					// firestore later, we can open the new document in the tab menu
					this.userJustCreatedDocument = returnData;

					

					const selectedTreeNodeId = this.$refs.sharedTreeComponent.treeActiveItem[0]; // is undefined if nothing is selected in tree

					// Find selected parent item
					let parentNodeId = (selectedTreeNodeId) ? selectedTreeNodeId : 'root' ;
					let positionInTree;
					let sharedRootId;

					// Get the order position
					if (selectedTreeNodeId) 
					{
						const selectedItem = agile.getObjectById(this.$refs.sharedTreeComponent.treeItems, selectedTreeNodeId);
						
						if (selectedItem.sharedRootId)
						{
							if (selectedItem.sharedRootId === 'sharedRoot')
							{
								sharedRootId = selectedItem.id;
							}
							else
							{
								sharedRootId = selectedItem.sharedRootId;
							}
						}
						else
						{
							sharedRootId = 'sharedRoot';
						}




						if (selectedItem && selectedItem.children) // Make sure the content has the children array 
						{
							positionInTree = selectedItem.children.length;
						}
						else
						{
							//this.$root.$alert("Warning", 'You can only add new view items to folders or the root. Your new view item is added to the root instead.');
							positionInTree = this.$refs.sharedTreeComponent.treeItems.length;
							parentNodeId = 'root';
						}
					}
					else
					{
						positionInTree = this.$refs.sharedTreeComponent.treeItems.length;
						sharedRootId = 'sharedRoot';
					}


					/* collection.add(
					{
						// --------------------------------------------------------------------
						//	
						//	Creation of the content document here!!!
						//	1: Create the wrapper document (for collections of data and to provide metadata)
						//	2: Create the document subcollection, where actual data will reside
						//	3: There will also be a subcollection for archives, which will be
						//	   made when the user starts to edit the document.
						//
						// --------------------------------------------------------------------

						visibility: 'draft',
						trash: false,
						sharedContent: false,
						
						editorMetaData:
						{
							treeNodeLabel: returnData.createdName,
							treeNodeParent: parentNodeId,
							treeNodePosition: positionInTree,
							templateName: returnData.docData.name,
							templateId: returnData.docData.id,
						},

						contentMetaData: returnData.docData.data.settings,

					})
					.then((docRef) =>
					{
						// ------------------------------------------------
						//	Create the real document for content
						// ------------------------------------------------

						// #Todo Make sure that if creation of sub collection document fails, then revert the creation as a whole
						collection.doc(docRef.id).collection('document').doc('content').set(
						{
							name: returnData.createdName,
						})
						.then(() =>
						{
							console.log('* Created sub collection doc');
						})
						.catch((error) =>
						{
							console.log('Error creating new sub collection content:', error.message);
						});

					})
					.catch((error) =>
					{
						console.log('Error creating new content:', error.message);
					}); */

					// Setup command
					const sharedCollection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content');
					
					
					sharedCollection.add(
					{
						// --------------------------------------------------------------------
						//
						//	Creation of the shared content here
						//
						// --------------------------------------------------------------------

						visibility: 'draft',
						trash: false,
						sharedContent: true,
						sharedRootId: sharedRootId,
						
						editorMetaData:
						{
							treeNodeLabel: returnData.createdName,
							treeNodeParent: parentNodeId,
							treeNodePosition: positionInTree,
							templateName: returnData.docData.name,
							templateId: returnData.docData.id,
						},

						contentMetaData: returnData.docData.data.settings,

					})
					.then((docRef) =>
					{
						// ------------------------------------------------
						//	Create the real document for content
						// ------------------------------------------------
						
						// #Todo Make sure that if creation of sub collection document fails, then revert the creation as a whole
						sharedCollection.doc(docRef.id).collection('document').doc('content').set(
						{
							name: returnData.createdName,
							trash: false,
						})
						.then(() =>
						{
							//console.log('* Created shared sub collection doc');
						})
						.catch((error) =>
						{
							console.log('Error creating new sub collection content:', error.message);
						});

						
						// ----------------------------------
						//	Now we also need to create
						//	where shared content resides in
						//	the content tree, if we are
						//	creating inside shared content.
						// ----------------------------------

						const contentCollection = fb.db
							.collection('content-collection')
							.doc('content-doc')
							.collection(this.routeKey)
							.doc(this.routeKey)
							.collection('content');

						contentCollection.where('originalId', '==', parentNodeId).get()
						.then((querySnapshot) =>
						{
							if (querySnapshot.empty) return;
							
							const syncBatch = fb.db.batch();

							querySnapshot.forEach((doc) =>
							{
								const docData = doc.data();
								const setSharedRootId = (docData.sharedRootId === 'sharedRoot') ? doc.id : docData.sharedRootId ;
								
								syncBatch.set(contentCollection.doc(), 
								{
									// --------------------------------------------------------------------
									//
									//	Creation of the shared content here
									//
									// --------------------------------------------------------------------

									visibility: 'draft',
									trash: false,
									sharedContent: true,
									sharedRootId: setSharedRootId,
									originalId: docRef.id,

									editorMetaData:
									{
										treeNodeLabel: returnData.createdName,
										treeNodeParent: parentNodeId,
										treeNodePosition: 99999,
										templateName: returnData.docData.name,
										templateId: returnData.docData.id,
									},

									contentMetaData: returnData.docData.data.settings,

								});
							});

							syncBatch.commit()
							.then(() =>
							{
								//console.log("Operation create shared content sync completed!");
							})
							.catch((error) =>
							{
								this.$root.$alert("Error batch creating shared content in content tree", error.message);
							});
						})
						.catch((error) =>
						{
							console.log('Error creating new shared content:', error.message);
						});

					})
					.catch((error) =>
					{
						console.log('Error creating new shared content:', error.message);
					});
				}
			});
		},



		// --------------------------------------------------------------------
		//
		//	Create new sorting folder
		//
		// --------------------------------------------------------------------

		createSharedContentFolder()
		{
			const selectedTreeNodeId = this.$refs.sharedTreeComponent.treeActiveItem[0]; // is undefined if nothing is selected in tree
			const selectedItem = agile.getObjectById(this.$refs.sharedTreeComponent.treeItems, selectedTreeNodeId);

			if (selectedItem && selectedItem.nodeType === 'shared-content')
			{
				this.$root.$alert('Wrong move', 'Can not nest sorting folders inside shared content.');
				return;
			}
			

			this.$root.$setName('Name of sorting folder') // Open dialog box to set name
			.then((nameReturned) =>
			{
				if (nameReturned)
				{
					// We store this property, so when we receive the new doucment from
					// firestore later, we can open the new document in the tab menu
					this.userJustCreatedDocument = nameReturned;


					//for (let i = 0; i < 100; i++) // STRESS TEST
					//{
					// Setup command
					const collection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content-sorting-folders');

					
					// Find selected parent item
					let parentNodeId = (selectedTreeNodeId) ? selectedTreeNodeId : 'root' ;
					let positionInTree;

					// Get the order position
					if (selectedTreeNodeId) 
					{
						if (selectedItem && selectedItem.children) // If we have selected a *folder* in the tree, then the 'children' object will exist.
						{
							positionInTree = selectedItem.children.length;
						}
						else
						{
							//this.$root.$alert("Warning", 'You can only add new view items to folders or the root. Your new view item is added to the root instead.');
							positionInTree = this.$refs.sharedTreeComponent.treeItems.length;
							parentNodeId = 'root';
							//return; // Abort further operations
						}
					}
					else
					{
						positionInTree = this.$refs.sharedTreeComponent.treeItems.length;
					}
					
					collection.add(
					{
						editorMetaData:
						{
							treeNodeLabel: nameReturned,
							treeNodeParent: parentNodeId,
							treeNodePosition: positionInTree
						},
						/* name: nameReturned,//+" "+i,
						metaData:
						{
							treeParent: parentNodeId,
							treePosition: positionInTree,
						}, */
					})
					.then((docRef) =>
					{
						docRef;
						//console.log("Document written with ID: ", docRef.id);
					})
					.catch((error) =>
					{
						console.log('Error creating sorting folder:', error.message);
					});
					//}//////////////////
				}
			});
		},
		


		

		

		

		// ----------------------------------
		//	Get data for the tree, and let
		//	it keep load changes live.
		// ----------------------------------

		initializeTreeContentLiveListener()
		{
			// Reset tree before we start live listeners

			if (this.$refs.treeComponent) this.$refs.treeComponent.treeItems = [];


			// --------------------------------------------------------------------
			//
			//	Live connection for content
			//
			// --------------------------------------------------------------------
			
			const contentCollection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('content').where("trash", "==", false);


			// Gogogo, go live
			this.unsubscribeLiveContent = contentCollection.onSnapshot(res =>
			{
				const changes = res.docChanges();
				
				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						// Build tree structure
						const docData = change.doc.data();
						docData.id = change.doc.id;
						docData.folder = true;
						docData.doc = change.doc; // This sucks, back-referenceing this. Oh well... fix in the future
						docData.nodeType = (docData.sharedContent) ? 'shared-content' : 'content' ;
						docData.children = [];
						
						// Tree icon
						if (docData.contentMetaData && docData.contentMetaData.iconEditor && docData.contentMetaData.iconEditor !== 'default')
						{
							docData.treeIcon = docData.contentMetaData.iconEditor;
						}
						else
						{
							docData.treeIcon = 'mdi-card-text-outline';
						}


						this.$refs.treeComponent.insertInTree(docData);
						
						// When a user has just made a new document!
						if (this.hasLoadedInitialContentTree && this.userJustCreatedDocument && this.userJustCreatedDocument.createdName === docData.editorMetaData.treeNodeLabel)
						{
							// Open new made item in tab menu
							//this.$refs.tabsComponent.openViewEditorWithLiveListener(change.doc.id);
							
							// Open parent folder of thew new document if closed
							const newDocParent = agile.getObjectParentIdByChildId(this.$refs.treeComponent.treeItems, change.doc.id);

							if (!this.$refs.treeComponent.treeOpenNodes.includes(newDocParent))
							{
								this.$refs.treeComponent.treeOpenNodes.push(newDocParent);
							}

							// Reset
							this.userJustCreatedDocument = null;
						}
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === 'modified')
					{
						const docData = change.doc.data();
						docData.id = change.doc.id;

						if (docData.trash === true)
						{
							agile.getAndRemoveObjectById(this.$refs.treeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
							// Update tree
							// We need to tick one before we go go
							setTimeout(this.$refs.treeComponent.updateTreeDrag, 1);
						}
						else
						{
							this.$refs.treeComponent.updateTreeItem(docData);
							this.$refs.tabsComponent.liveUpdateWrapper(docData);
						}
						
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === 'removed')
					{
						agile.getAndRemoveObjectById(this.$refs.treeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(this.$refs.treeComponent.updateTreeDrag, 1);
					}
				});

				// On the first response from firestore, all documents are shipped to us.
				// Now we can set this for convenience
				this.hasLoadedInitialContentTree = true;

			},
			er =>
			{
				this.$root.$alert('Error', er.message);
			});


		},



		// ----------------------------------
		//	Get data for the tree, and let
		//	it keep load changes live.
		// ----------------------------------

		initializeSharedTreeContentLiveListener()
		{
			// Reset tree before we start live listeners

			if (this.$refs.sharedTreeComponent) this.$refs.sharedTreeComponent.treeItems = [];


			// --------------------------------------------------------------------
			//
			//	Live connection for shared content
			//
			// --------------------------------------------------------------------
			
			const sharedContentCollection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('shared-content').where("trash", "==", false);


			// Gogogo, go live
			this.unsubscribeLiveSharedContent = sharedContentCollection.onSnapshot(res =>
			{
				const changes = res.docChanges();
				
				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						// Build tree structure
						const docData = change.doc.data();
						docData.id = change.doc.id;
						docData.folder = true;
						docData.doc = change.doc; // This sucks, back-referenceing this. Oh well... fix in the future
						docData.nodeType = 'shared-content';
						docData.children = [];

						// Tree icon
						if (docData.contentMetaData && docData.contentMetaData.iconEditor && docData.contentMetaData.iconEditor !== 'default')
						{
							docData.treeIcon = docData.contentMetaData.iconEditor;
						}
						else
						{
							docData.treeIcon = 'mdi-card-text-outline';
						}

						

						this.$refs.sharedTreeComponent.insertInTree(docData);
						
						// When a user has just made a new document!
						if (this.hasLoadedInitialSharedContentTree && this.userJustCreatedDocument.createdName === docData.editorMetaData.treeNodeLabel)
						{
							// Open new made item in tab menu
							//this.$refs.sharedTreeComponent.openViewEditorWithLiveListener(change.doc.id);
							
							// Open parent folder of thew new document if closed
							const newDocParent = agile.getObjectParentIdByChildId(this.$refs.sharedTreeComponent.treeItems, change.doc.id);

							if (!this.$refs.sharedTreeComponent.treeOpenNodes.includes(newDocParent))
							{
								this.$refs.sharedTreeComponent.treeOpenNodes.push(newDocParent);
							}

							// Reset
							this.userJustCreatedDocument = null;
						}
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === 'modified')
					{
						const docData = change.doc.data();
						docData.id = change.doc.id;

						if (docData.trash === true)
						{
							agile.getAndRemoveObjectById(this.$refs.sharedTreeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
							// Update tree
							// We need to tick one before we go go
							setTimeout(this.$refs.sharedTreeComponent.updateTreeDrag, 1);
						}
						else
						{
							this.$refs.sharedTreeComponent.updateTreeItem(docData);
							this.$refs.tabsComponent.liveUpdateWrapper(docData);
						}
						
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === 'removed')
					{
						agile.getAndRemoveObjectById(this.$refs.sharedTreeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(this.$refs.sharedTreeComponent.updateTreeDrag, 1);
					}
				});

				// On the first response from firestore, all documents are shipped to us.
				// Now we can set this for convenience
				this.hasLoadedInitialSharedContentTree = true;

			},
			er =>
			{
				this.$root.$alert('Error', er.message);
			});


			// --------------------------------------------------------------------
			//
			//	Live connection for shared content sorting folders
			//
			// ---------------------------------------------------------------------

			const folderCollection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('shared-content-sorting-folders');//.where("trash", "==", false);


			// Gogogo, go live
			this.unsubscribeLiveFolders = folderCollection.onSnapshot(res =>
			{
				const changes = res.docChanges();
				
				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						// Build tree structure
						const docData = change.doc.data();
						docData.id = change.doc.id;
						docData.folder = true;
						docData.doc = change.doc; // This sucks, back-referenceing this. Oh well... fix in the future
						docData.nodeType = 'sorting-folder';
						docData.children = [];

						this.$refs.sharedTreeComponent.insertInTree(docData);

						// When a user has just made a new document!
						if (this.hasLoadedInitialSortingFolderTree && this.userJustCreatedDocument === docData.editorMetaData.treeNodeLabel)
						{
							// Open parent folder of thew new document if closed
							const newDocParent = agile.getObjectParentIdByChildId(this.$refs.sharedTreeComponent.treeItems, change.doc.id);

							if (!this.$refs.sharedTreeComponent.treeOpenNodes.includes(newDocParent))
							{
								this.$refs.sharedTreeComponent.treeOpenNodes.push(newDocParent);
							}

							// Reset
							this.userJustCreatedDocument = null;
						}
						
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === 'modified')
					{
						const docData = change.doc.data();
						docData.id = change.doc.id;
						
						this.$refs.sharedTreeComponent.updateTreeItem(docData);
						this.$refs.tabsComponent.liveUpdateWrapper(docData);
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === 'removed')
					{
						agile.getAndRemoveObjectById(this.$refs.sharedTreeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(this.$refs.sharedTreeComponent.updateTreeDrag, 1);
					}

				});

				// On the first response from firestore, all documents are shipped to us.
				// Now we can set this for convenience
				this.hasLoadedInitialSortingFolderTree = true;

			},
			er =>
			{
				this.$root.$alert('Error', er.message);
			});

		},




		// --------------------------------------------------------------------
		//
		//	Delete items in content tree (move to trash bin)
		//
		// --------------------------------------------------------------------

		deleteSelectedContentTreeItem()
		{	
			var activeItem = this.$refs.treeComponent.treeActiveItem[0];

			// ----------------------------------
			//	Do some cheking before we start to delete
			// ----------------------------------

			if (!activeItem)
			{
				//this.$root.$alert('No item', 'No selected item to delete');
				return;
			}

			
			this.$root.$confirm('Deleting', 'Do you really want to delete this item (and possible nested items)?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// Get item and mark it for deletion
					const itemToTrash = agile.getObjectById(this.$refs.treeComponent.treeItems, activeItem);
					
					if (itemToTrash === null)
					{
						this.$root.$alert('Error', 'Item marked for deletion is null for some reason.');
						return;
					}

					if (itemToTrash.sharedContent === true && itemToTrash.sharedRootId !== 'sharedRoot')
					{
						this.$root.$alert('Can not delete', 'Nested content within shared content must be deleted from the shared content tree.');
						return;
					}


					// ----------------------------------
					//	Batch possible nested nodes
					// ----------------------------------

					const collection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('content');

					// #Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
					const batch = fb.db.batch();
					// #Todo: Look here, trashed item is grounded to root. Do the same for shared content deletion in the function below
					batch.set(collection.doc(itemToTrash.id), { trash: true, metaData: { treeParent: 'root '} }, { merge: true } );
					batch.set(collection.doc(itemToTrash.id).collection('document').doc('content'), { trash: true }, { merge: true } );
					
					// Go through all the possible children as well
					agile.recursivelyAddFirestoreBatchMoveToTrash(collection, null, itemToTrash.children, batch);
					

					// ----------------------------------
					//	Do the deletion
					// ----------------------------------

					batch.commit()
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Deleted item(s)';
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
					
				}
			});
		},




		// --------------------------------------------------------------------
		//
		//	Delete items in shared content tree (move to trash bin)
		//
		// --------------------------------------------------------------------

		deleteSharedContentTreeItem()
		{	
			var activeItem = this.$refs.sharedTreeComponent.treeActiveItem[0];

			// ----------------------------------
			//	Do some cheking before we start to delete
			// ----------------------------------

			if (!activeItem)
			{
				//this.$root.$alert('No item', 'No selected item to delete');
				return;
			}

			
			this.$root.$confirm('Deleting', 'Do you really want to delete this item (and possible nested items)?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// Get item and mark it for deletion
					const itemToTrash = agile.getObjectById(this.$refs.sharedTreeComponent.treeItems, activeItem);
					
					if (itemToTrash === null)
					{
						this.$root.$alert('Error', 'Item marked for deletion is null for some reason');
						return;
					}
					
					this.$root.ai_app.showProgressWheel = true;

					// ----------------------------------
					//	Setup databases
					// ----------------------------------

					const contentCollection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('content');

					const sharedCollection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content');

					const folderCollection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content-sorting-folders');

					
					// Collect shared content id's to be deleted. We want to also delete its disributed shared content in the content tree
					const docsToTrashOrDelete = [];
					
					// Go through all the possible children as well
					agile.recursivelyGetFirestoreStuffToTrashOrDelete([itemToTrash], docsToTrashOrDelete);
					
					(async () =>
					{
						const promises = [];

						// Get shared content from the main content tree
						for (let i = 0; i < docsToTrashOrDelete.length; i++)
						{
							if (docsToTrashOrDelete[i].type === 'trash')
							{
								promises.push(
									contentCollection.where('originalId', '==', docsToTrashOrDelete[i].id).where('trash', '==', false).get()
									.then((querySnapshot) =>
									{
										const returnArray = [];
										querySnapshot.forEach((doc) =>
										{
											returnArray.push(doc.id);
										});
										return returnArray;
									})
									.catch((error) =>
									{
										console.log("Error getting shared content from main tree (for trash deletion)", error.message);
										return 'error';
									})
								);
							}
						}

						let sharedDocsToDelete = await Promise.all(promises);

						for (let i = 0; i < sharedDocsToDelete.length; i++)
						{
							for (let j = 0; j < sharedDocsToDelete[i].length; j++)
							{
								// If any error, abort operation! The error message itself witll be console.logged from the request above
								this.$root.ai_app.showProgressWheel = false;
								if (sharedDocsToDelete[i][j] == 'error') return;

								// Keep populate the delete array with shared content to delete
								docsToTrashOrDelete.push( { id:sharedDocsToDelete[i][j], type: 'contentTrash' } );
							}
						}

						if (docsToTrashOrDelete.length > 500)
						{
							this.$root.$alert('Too many objects to delete', 'We can at the moment not delete more than 500 nodes at once (this includes the shared content nodes). Please split up the deletion into smaller batches.');
							this.$root.ai_app.showProgressWheel = false;
							return;
						}

						// OK, finally we start batching deletion
						const batch = fb.db.batch();

						for (let i = 0; i < docsToTrashOrDelete.length; i++)
						{
							if (docsToTrashOrDelete[i].type === 'trash')
							{
								batch.set(sharedCollection.doc(docsToTrashOrDelete[i].id), { trash: true }, { merge: true } );
								batch.set(sharedCollection.doc(docsToTrashOrDelete[i].id).collection('document').doc('content'), { trash: true }, { merge: true } );
							}
							else if (docsToTrashOrDelete[i].type === 'contentTrash')
							{
								batch.set(contentCollection.doc(docsToTrashOrDelete[i].id), { trash: true }, { merge: true } );
							}
							else if (docsToTrashOrDelete[i].type === 'delete')
							{
								batch.delete(folderCollection.doc(docsToTrashOrDelete[i].id));
							}
						}

						batch.commit()
						.then(() =>
						{
							// ----------------------------------
							//	Now delete the shared content
							// ----------------------------------

							this.$root.ai_app.snackbarText = 'Deleted item(s)';
							this.$root.ai_app.snackbarTimeout = 4000;
							this.$root.ai_app.snackbar = true;

							this.$root.ai_app.showProgressWheel = false;

						})
						.catch((error) =>
						{
							this.$root.ai_app.showProgressWheel = false;
							this.$root.$alert("Error", error.message);
						});

					})();


					
				}
			});
		},





		// --------------------------------------------------------------------
		//
		//	PERMENANTELY delete trash
		//
		// --------------------------------------------------------------------
		

		permantentlyDeleteTrash()
		{
			if (agile.loggedInUser.superAdmin) // #Todo poor protection, but not critical for deleting trash
			{
				this.$root.$confirm('Permanently delete', 'Do you really want to dempty the trash can for good?', { color: 'error' } )
				.then((confirm) =>
				{
					if (confirm)
					{
						const collection = fb.db
							.collection('content-collection')
							.doc('content-doc')
							.collection(this.routeKey)
							.doc(this.routeKey)
							.collection('content');

						// First get all trash documents
						collection.where('trash', '==', true).get()
						.then((querySnapshot) =>
						{
							if (querySnapshot.empty)
							{
								this.keepPermantentlyDeletingSharedTrashNow();
							}
							else
							{
								const batch = fb.db.batch();

								querySnapshot.forEach((doc) =>
								{
									// #Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
									
									batch.delete(collection.doc(doc.id).collection('document').doc('content'));
									batch.delete(collection.doc(doc.id));
								});
								//.doc(docRef.id).collection('document').doc('content')

								batch.commit()
								.then(() =>
								{
									this.keepPermantentlyDeletingSharedTrashNow();
								})
								.catch((error) =>
								{
									this.$root.$alert("Error batch deleting trash", error.message);
								});

							}
						})
						.catch((error) =>
						{
							console.log("Error getting documents to trash: ", error);
						});

					}
				});
			}
		},

		keepPermantentlyDeletingSharedTrashNow()
		{
			if (agile.loggedInUser.superAdmin) // #Todo poor protection, but not critical for deleting trash
			{
				
				const collection = fb.db
						.collection('content-collection')
						.doc('content-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('shared-content');

				// First get all trash documents
				collection.where('trash', '==', true).get()
				.then((querySnapshot) =>
				{
					if (querySnapshot.empty)
					{
						this.$root.ai_app.snackbarText = 'Trash can empty';
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
					}
					else
					{
						const batch = fb.db.batch();

						querySnapshot.forEach((doc) =>
						{
							// #Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
							batch.delete(collection.doc(doc.id).collection('document').doc('content'));
							batch.delete(collection.doc(doc.id));
						});

						batch.commit()
						.then(() =>
						{
							this.$root.ai_app.snackbarText = 'Trash can empty';
							this.$root.ai_app.snackbarTimeout = 4000;
							this.$root.ai_app.snackbar = true;
						})
						.catch((error) =>
						{
							this.$root.$alert("Error batch deleting trash", error.message);
						});
						
					}
				})
				.catch((error) =>
				{
					console.log("Error getting documents to trash: ", error);
				});

			}
				
		},



		// ----------------------------------
		//	Sync user
		// ----------------------------------
		
		syncUserStateFromFirestore()
		{
			// Get folder open/closed state for user since last session
			if (agile.loggedInUser.uid)
			{
				fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(this.routeKey).get()
				.then((doc) =>
				{
					if (doc.exists)
					{
						const docData = doc.data();

						
						// NB: It will throw error the first time a user is visiting this page, since no states are saved.
						// Therefore we use try catch here, because error checking all thes properties are boring.

						// Sync open nodes in tree
						try {
							this.$refs.treeComponent.treeOpenNodes = docData.contentEditorTreeState;
						} catch (er) { console.log(er) }
						
						this.$refs.treeComponent.hasInitializedUserSync = true;


						try {
							this.$refs.sharedTreeComponent.treeOpenNodes = docData.sharedContentEditorTreeState;
						} catch (er) { console.log(er) }
						
						this.$refs.sharedTreeComponent.hasInitializedUserSync = true;
						


						// Sync open documents in tab
						try {
							this.$refs.tabsComponent.syncInitialTabs(
								docData.contentEditorActiveTab,
								docData.contentEditorOpenTabs
							);
						} catch (er) { console.log(er) }
						this.$refs.tabsComponent.hasInitializedUserSync = true;


					}
					else
					{
						// We failed, but we still ned top open these props, so we can save new. #Todo: I guess no good coding here :s
						this.$refs.treeComponent.hasInitializedUserSync = true;
						this.$refs.tabsComponent.hasInitializedUserSync = true;

						// doc.data() will be undefined in this case
						console.log("syncUserStateFromFirestore(): No such document!");
					}
				})
				.catch((error) =>
				{
					console.log('Error getting user document:', error.message);
				});

			}
		},


		
		// --------------------------------------------------------------------
		//
		//	On resize function for the 'left' and 'right' panes
		//
		// --------------------------------------------------------------------

		onResize()
		{
			
			// Todo: Oh my god boring coding
			if (window.innerWidth < 600)
			{
				this.isMiniDrawer = true;
				this.leftMenuPaneWidth = 56;	//xs
			}
			else if (window.innerWidth < 960)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 260;	//sm
			}
			else if (window.innerWidth < 1264)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 330;	//md
			}
			else if (window.innerWidth < 1904)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 370;	//lg
			}
			else
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 400;	//xl
			}
			
			this.rightContentPaneWidth = window.innerWidth-this.leftMenuPaneWidth;

			const alwaysRemove = window.innerHeight-this.appBarHeight-this.toolBarSecondaryHeight;

			const halfHeight = ((alwaysRemove-(this.smallTitleBarHeight*2))/2)+'px';
			const fullHeight = (alwaysRemove-this.smallTitleBarHeight)+'px';
			const fullOrNot = (this.showSharedContentMenu && this.showContentMenu);

			this.$refs.treeComponent.$refs.contentTree.$el.style.height = (fullOrNot) ? halfHeight : fullHeight;
			this.$refs.sharedTreeComponent.$refs.contentTree.$el.style.height = (fullOrNot) ? halfHeight : fullHeight;
			
		},
		


		onKeyPress(e)
		{
			if (e.keyCode === 71 && e.ctrlKey)
			{
				this.createContent();
				e.preventDefault();
				
			}
			else if (e.keyCode === 66 && e.ctrlKey)
			{
				this.createSharedContent();
				e.preventDefault();
			}

		},

		
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);

		// Close down live listeners
		//console.log("* Unsubscribing live listeners for page types");
		if (this.unsubscribeLiveFolders) this.unsubscribeLiveFolders();
		if (this.unsubscribeLiveContent) this.unsubscribeLiveContent();
		if (this.unsubscribeLiveSharedContent) this.unsubscribeLiveSharedContent();

		document.removeEventListener("keydown", this.onKeyPress);

		AiEventBus.$off('authenticationComplete', this.syncUserStateFromFirestore);
	},

};
</script>
